import React from 'react';
import SideBar from '../../SideBar';
import HeaderSection from '../../HeaderSection';
import { Link } from 'react-router-dom';
import '../../../../assets/css/app-countdown-timer-module.css';
import '../../../../assets/css/loader.css'; 

export default function WhatsNewCountdownTimer() {

  return (
    <>
      <div className="container-scroller">
        <SideBar />
        <div className="main-panel">
          <div className="content-wrapper">
            <HeaderSection />
            <div className="google-reviews-saction-one">
              <div className="google-left-one">
                <h2>Countdown Timer</h2>
                <ul>
                  <li>
                    <Link to="/customer/apps/countdown-timer">
                      <img src={`${process.env.PUBLIC_URL}/images/icon-1.png`} alt="icon-1" />Widget
                    </Link>
                  </li>
                  <li>
                    <Link to="/customer/apps/countdown-timer/wishlist">
                      <img src={`${process.env.PUBLIC_URL}/images/icon-2.png`} alt="icon-2.png" />Request a Feature
                    </Link>
                  </li>
                  <li>
                    <Link to="/customer/apps/countdown-timer/whats-new" className="active">
                      <img src={`${process.env.PUBLIC_URL}/images/icon-3.png`} alt="icon-3" />What’s New
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="google-reviews-saction-tow">
              <div className='request-any-row'>
                <div className='request-any-row-left'>
                  <h2>Tell us how you found the updates!</h2>
                  <p>Your feedback is something that helps us navigate and take the right path. Let us know your thoughts about the updates, we always wait to hear from you with bated breath!</p>
                </div>
                <div className="request-any-row-right">
                  <Link to="#">
                    See All Updates
                  </Link>
                </div>
              </div>
              <div className="request-any-row-tow">
                <div className='row'>

                  <div className="col-md-3">
                    <span>Fixed</span>
                    <div className="request-any-row-tow-box what-news-box">
                      <Link to="#">
                        <h4>Issue with link expiration for business owners' avatars fixed</h4>
                        <p>August 21, 2024</p>
                        <ul div className="replay-view">
                          <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                          <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                        </ul>
                        <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <span>Fixed</span>
                    <div className="request-any-row-tow-box what-news-box">
                      <Link to="#">
                        <h4>Issue with link expiration for business owners' avatars fixed</h4>
                        <p>August 21, 2024</p>
                        <ul div className="replay-view">
                          <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                          <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                        </ul>
                        <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <span>Fixed</span>
                    <div className="request-any-row-tow-box what-news-box">
                      <Link to="#">
                        <h4>Issue with link expiration for business owners' avatars fixed</h4>
                        <p>August 21, 2024</p>
                        <ul div className="replay-view">
                          <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                          <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                        </ul>
                        <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <span>Fixed</span>
                    <div className="request-any-row-tow-box what-news-box">
                      <Link to="#">
                        <h4>Issue with link expiration for business owners' avatars fixed</h4>
                        <p>August 21, 2024</p>
                        <ul div className="replay-view">
                          <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                          <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                        </ul>
                        <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <span>Fixed</span>
                    <div className="request-any-row-tow-box what-news-box">
                      <Link to="#">
                        <h4>Issue with link expiration for business owners' avatars fixed</h4>
                        <p>August 21, 2024</p>
                        <ul div className="replay-view">
                          <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                          <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                        </ul>
                        <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <span>Fixed</span>
                    <div className="request-any-row-tow-box what-news-box">
                      <Link to="#">
                        <h4>Issue with link expiration for business owners' avatars fixed</h4>
                        <p>August 21, 2024</p>
                        <ul div className="replay-view">
                          <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                          <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                        </ul>
                        <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <span>Fixed</span>
                    <div className="request-any-row-tow-box what-news-box">
                      <Link to="#">
                        <h4>Issue with link expiration for business owners' avatars fixed</h4>
                        <p>August 21, 2024</p>
                        <ul div className="replay-view">
                          <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                          <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                        </ul>
                        <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <span>Fixed</span>
                    <div className="request-any-row-tow-box what-news-box">
                      <Link to="#">
                        <h4>Issue with link expiration for business owners' avatars fixed</h4>
                        <p>August 21, 2024</p>
                        <ul div className="replay-view">
                          <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                          <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                        </ul>
                        <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className='see-all-feature-requests-button'><Link to="#">See All Updates</Link></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 